import "core-js/modules/es.reflect.construct.js";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.concat.js";

/* eslint-disable max-classes-per-file */

/*----------------------------------------------------*/
// Dependencies

/*----------------------------------------------------*/
import EventEmitter from 'eventemitter3'; // TODO: maybe factory "on" & "off" functions

/*----------------------------------------------------*/
// Constants & Variables

/*----------------------------------------------------*/

var proxies = ['emit', 'once', 'removeListener', 'removeAllListeners', 'eventNames', 'listeners'];
/*----------------------------------------------------*/
// Module

/*----------------------------------------------------*/

var Emitter = /*#__PURE__*/function () {
  function Emitter() {
    _classCallCheck(this, Emitter);

    // emitter instance
    this.$emitter = new EventEmitter();
  } // Enhance some methods
  // --------------------------------------------------


  _createClass(Emitter, [{
    key: "on",
    value: function on() {
      var _this = this;

      // allow to pass an object of listeners
      if (_typeof(arguments.length <= 0 ? undefined : arguments[0]) === 'object') {
        var ctxt = (arguments.length <= 1 ? undefined : arguments[1]) || this;
        Object.entries(arguments.length <= 0 ? undefined : arguments[0]).forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              name = _ref2[0],
              fn = _ref2[1];

          _this.$emitter.on(name, fn, ctxt);
        });
      } else {
        this.$emitter.on(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], (arguments.length <= 2 ? undefined : arguments[2]) || this);
      }

      return this;
    }
  }, {
    key: "off",
    value: function off() {
      var _this2 = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      // allow to pass an object of listeners
      if (_typeof(args[0]) === 'object') {
        Object.entries(args[0]).forEach(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              name = _ref4[0],
              fn = _ref4[1];

          var ctxt = args[1] || _this2;

          _this2.$emitter.removeListener(name, fn, ctxt);
        });
      } else if (args.length > 1) {
        this.$emitter.removeListener(args[0], args[1], args[2] || this);
      } else {
        this.$emitter.removeAllListeners(args[0]);
      }

      return this;
    }
  }]);

  return Emitter;
}(); // attach proxieds methods


export { Emitter as default };
proxies.forEach(function (method) {
  Emitter.prototype[method] = function self() {
    this.$emitter[method](arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], (arguments.length <= 2 ? undefined : arguments[2]) || this);
    return this;
  };
});
/*----------------------------------------------------*/
// Mixin

/*----------------------------------------------------*/

export var EmitterMixin = function EmitterMixin(superclass) {
  var EmetterMixin = /*#__PURE__*/function (_superclass) {
    _inherits(EmetterMixin, _superclass);

    var _super = _createSuper(EmetterMixin);

    function EmetterMixin() {
      var _this3;

      _classCallCheck(this, EmetterMixin);

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      _this3 = _super.call.apply(_super, [this].concat(args)); // emitter instance

      _this3.$emitter = new EventEmitter();
      return _this3;
    } // Alter some methods to enhance them
    // --------------------------------------------------


    _createClass(EmetterMixin, [{
      key: "on",
      value: function on() {
        var _this4 = this;

        // allow to pass an object of listeners
        if (_typeof(arguments.length <= 0 ? undefined : arguments[0]) === 'object') {
          var ctxt = (arguments.length <= 1 ? undefined : arguments[1]) || this;
          Object.entries(arguments.length <= 0 ? undefined : arguments[0]).forEach(function (_ref5) {
            var _ref6 = _slicedToArray(_ref5, 2),
                name = _ref6[0],
                fn = _ref6[1];

            _this4.$emitter.on(name, fn, ctxt);
          });
        } else {
          this.$emitter.on(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], (arguments.length <= 2 ? undefined : arguments[2]) || this);
        }

        return this;
      }
    }, {
      key: "off",
      value: function off() {
        var _this5 = this;

        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        // allow to pass an object of listeners
        if (_typeof(args[0]) === 'object') {
          Object.entries(args[0]).forEach(function (_ref7) {
            var _ref8 = _slicedToArray(_ref7, 2),
                name = _ref8[0],
                fn = _ref8[1];

            var ctxt = args[1] || _this5;

            _this5.$emitter.removeListener(name, fn, ctxt);
          });
        } else if (args.length > 1) {
          this.$emitter.removeListener(args[0], args[1], args[2] || this);
        } else {
          this.$emitter.removeAllListeners(args[0]);
        }

        return this;
      }
    }]);

    return EmetterMixin;
  }(superclass); // attach proxieds methods


  proxies.forEach(function (method) {
    superclass.prototype[method] = function self() {
      this.$emitter[method](arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], (arguments.length <= 2 ? undefined : arguments[2]) || this);
      return this;
    };
  });
  return EmetterMixin;
};

if (module.hot) {
  module.hot.accept(function (err) {
    if (err) {
      console.error(err);
    }
  });
}